export function getAllowedDomains() {
  const domains = import.meta.env.VITE_ALLOWED_DOMAINS;
  return domains ? JSON.parse(domains) : [];
}
